<template>
    <div>
        <div class="p-1">Showing {{filteredActs.length}} items</div>
        <table class="table table-striped">
            <tbody>
                <tr v-for="(show, index) in filteredActs" :key="index">
                    <td class="p-4">
                        <div class="font-weight-bold">{{show.Number}}<span v-show="show.Number">.</span> <span v-html="highlight(show.SongTitle)"></span></div>
                        <span v-for="(dancer, index) in show.Dancers" :key="index">
                            <span v-if="index > 0">, </span>
                            <!-- <span v-html="highlight(dancer.Name)"></span> -->
                            <span v-if="dancer.HasProfile">
                                <router-link class="font-weight-bold" :to="{path: '/seniors', hash: '#' + dancer.Name.replace(/\s+/g, '_')}">
                                    <span v-html="highlight(dancer.Name)"></span>
                                </router-link>
                            </span>
                            <span v-else v-html="highlight(dancer.Name)"></span>
                        </span>
                    </td>
                </tr>
                <tr v-show="filteredActs.length == 0">
                    <td class="text-center">There are no records matching your request</td>
                </tr>
            </tbody>
        </table>
    </div>
</template>

<script>
export default {
    props: {
        value: {
            required: true,
            type: Array
        },
        searchTerm: {
            type: String
        }
    },
    mounted() {
        this.acts = this.value;
    },
    data() {
        return {
            acts: [],            
        }
    },
    watch: {
        searchTerm(value) {
            this.searchTerm = value;
        }
    },
    computed: {
        filteredActs() {
            var self = this;
            if (self.searchTerm && self.searchTerm.length > 2) {
                self.search();
            }
            else {
                self.acts = self.value;
            }
            return self.acts;
        },
        searchTerms() {
            var self = this;
            var retValue = [];
            if (self.searchTerm && self.searchTerm.length > 2) {
                var items = self.searchTerm.toUpperCase().split(",");
                for (var i = 0; i < items.length; i++) {
                    var item = items[i].trim();
                    if (item && item.length > 2) {
                        retValue.push(item);
                    }
                }
            }
            return retValue;
        }
    },
    methods: {
        search() {
            var self = this;
            this.acts = this.value.filter((x) => {
                var upperSongTitle = x.SongTitle.toUpperCase();
                for (var i = 0; i < self.searchTerms.length; i++) {
                    var index = upperSongTitle.indexOf(self.searchTerms[i]);
                    if (index > -1) {
                        return true;
                    }

                    index = x.Dancers.findIndex((y) => {
                        var upperDancerName = y.Name.toUpperCase();
                        var index = upperDancerName.indexOf(self.searchTerms[i]);
                        if (index > -1) {
                            return true;
                        }
                        return false;
                    });
                    if (index > -1) {
                        return true;
                    }
                }

                return false;
            });
        },
        escapeRegExp(pattern) {
          return pattern.replace(/[.*+?^${}()|[\]\\]/g, '\\$&');
        },
        highlight(value) {
            var self = this;
            if (value) {
                value = value
                    .replace(/&/g, '&amp;')
                    .replace(/</g, '&lt;')
                    .replace(/>/g, '&gt;');
            }

            if (self.searchTerm && self.searchTerm.length > 2) {
                var pattern = self.searchTerms.map(item => self.escapeRegExp(item)).join('|');
                var regex = new RegExp(pattern, "gi");
                value = value.replace(regex, (matched) => `<span class='highlight'>${matched}</span>`);
            }

            return value;
        },
    }
}
</script>